module.exports = __webpack_public_path__ + "static/media/cambio_exitoso.942a9c16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/cambio_exitoso.svg
// module id = 1783
// module chunks = 0